import { useState } from "react";

const DeclarationPledgePage = ({ handleSubmit, handleBack, formData }) => {
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="w-full min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white shadow-lg rounded-lg w-full max-w-6xl p-6">
        <h2 className="text-2xl font-bold text-center text-[#b60041] mb-6">
          Declaration and Pledge / الإقرار و التعهد
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm leading-6 text-gray-700 pb-20">
          {/* English Text - Left Column */}
          <div className="space-y-4 text-left md:col-span-1 w-full">
            <div className="h-full flex flex-col justify-between">
              <p>• I, the undersigned, certify that the information provided in this application is correct and complete. I grant the American University for Medical Sciences or any relevant official body the full right to verify it or use the attached documents, as they deem appropriate.</p>
              <p>• I authorize the American University for Medical Sciences to use the information provided by me for its educational purposes.</p>
              <p>• I also grant the American University of Medical Sciences the right to reject my application, cancel my enrollment, or expel me from the university if they discover forgery or inaccuracy in any of the information provided or any of the attached documents.</p>
              <p>• The American University for Medical has the right to accept or reject any application/request without having to justify any reason.</p>
              <p>• The American University for Medical Sciences also has the right to retain all fees paid in the event of this occurrence.</p>
              <p>• I also pledge, if accepted into the university, to complete and finalize all relevant procedures.</p>
              <p>• The information provided by me is considered the property of the college, which has the right to retain all documents submitted by me.</p>
              {/* <p>
                • I also agree and pledge, during my admission and study period at the university:
                <p className="pb-1 text-bold"></p>
                <br /><strong> I. </strong> To adhere to and fully respect the rules and regulations of the American University for Medical Sciences and the decisions issued by the university. Any violation thereof will subject me to the penalty determined by the university.
                <br /><strong> II. </strong> I also pledge to behave and conduct myself in a respectful and respectful manner, to address and treat all university staff and colleagues with respect, and to avoid anything that offends modesty or violates the traditions and customs of Kuwaiti society, whether during the admissions process or after admission.
                <br /><strong> III. </strong> I also pledge to preserve the university's reputation and refrain from defaming it or spreading rumors about it or its staff, whether inside or outside the university campus.
              </p> */}
            </div>
          </div>

          {/* Arabic Text - Right Column */}
          <div className="space-y-4 text-right md:col-span-1 w-full rtl">
            <div className="h-full flex flex-col justify-between">
              {/* First Item */}
              <div className="flex text-right justify-end w-full rtl">
                <p>أنا الموقع أدناه، أقر بصحة واكتمال المعلومات الواردة في هذا الطلب. وأمنح الجامعة الأمريكية للعلوم الطبية أو أي جهة رسمية مختصة الحق الكامل في التحقق منها أو استخدام المستندات المرفقة بما تراه مناسبًا</p>
                <strong className="ml-2">•</strong>
              </div>

              {/* Second Item */}
              <div className="flex text-right justify-end w-full">
                <p>أصرح للجامعة الأمريكية للعلوم الطبية باستخدام المعلومات التي قدمتها لأغراضها التعليمية</p>
                <strong className="ml-2">•</strong>
              </div>

              {/* Third Item */}
              <div className="flex text-right justify-end w-full">
                <p> كما أمنح الجامعة الأمريكية للعلوم الطبية الحق في رفض طلبي، أو إلغاء تسجيلي، أو فصلي من الجامعة إذا اكتشفت تزويرًا أو عدم دقة في أي من المعلومات المقدمة أو المستندات المرفقة</p>
                <strong className="ml-2">•</strong>
              </div>

              {/* Fourth Item */}
              <div className="flex text-right justify-end w-full">
                <p> يحق للجامعة الأمريكية للعلوم الطبية قبول أو رفض أي طلب دون إبداء أي أسباب</p>
                <strong className="ml-2">•</strong>
              </div>

              {/* Fifth Item */}
              <div className="flex text-right justify-end w-full">
                <p> كما يحق للجامعة الأمريكية للعلوم الطبية الاحتفاظ بجميع الرسوم المدفوعة في حال حدوث ذلك</p>
                <strong className="ml-2">•</strong>
              </div>

              {/* Sixth Item */}
              <div className="flex text-right justify-end w-full">
                <p> كما أتعهد، في حال قبولي في الجامعة، بإكمال جميع الإجراءات ذات الصلة وإتمامها</p>
                <strong className="ml-2">•</strong>
              </div>

              {/* Seventh Item */}
              <div className="flex text-right justify-end w-full">
                <p> تعد المعلومات التي قدمتها ملكًا للكلية، ولها الحق في الاحتفاظ بجميع المستندات التي قدمتها</p>
                <strong className="ml-2">•</strong>
              </div>
            </div>
          </div>

        </div>


        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm leading-6 text-gray-700">
          {/* English Text - Left Column */}
          <div className="space-y-4 text-left md:col-span-1 w-full">
            <div className="h-full flex flex-col justify-between">
              <p className="pb-5" ><strong> • </strong>  I also agree and pledge, during my admission and study period at the university:</p>
              <p className="pb-2" ><strong> 1. </strong> To adhere to and fully respect the rules and regulations of the American University for Medical Sciences and the decisions issued by the university. Any violation thereof will subject me to the penalty determined by the university.</p>
              <p className="pb-2" ><strong> 2. </strong> I also pledge to behave and conduct myself in a respectful and respectful manner, to address and treat all university staff and colleagues with respect, and to avoid anything that offends modesty or violates the traditions and customs of Kuwaiti society, whether during the admissions process or after admission.</p>
              <p className="pb-2" ><strong> 3. </strong> I also pledge to preserve the university's reputation and refrain from defaming it or spreading rumors about it or its staff, whether inside or outside the university campus.</p>

            </div>
          </div>

          {/* Arabic Text - Right Column */}
          <div className="space-y-4 text-right md:col-span-1 w-full rtl">


            <div className="h-full flex flex-col justify-between">
              <div className="flex text-right justify-end w-full rtl">
                <strong className="mr-2 pb-5"> : </strong>
                <p> كما أتعهد وأوافق، خلال فترة قبولي ودراستي في الجامعة</p>
                <strong className="ml-2"> • </strong>
              </div>

              <div className="flex text-right justify-end w-full rtl">
                <p> الالتزام التام بقواعد ولوائح الجامعة الأمريكية للعلوم الطبية والقرارات الصادرة عنها. وأي مخالفة لذلك ستعرضني للعقوبة التي تقررها الجامعة </p>
                <strong className="ml-2"> .1 </strong>
              </div>

              <div className="flex text-right justify-end w-full rtl">
                <p> أتعهد بالتصرف بأدب واحترام، ومخاطبة جميع موظفي الجامعة وزملائي باحترام، وتجنب كل ما يخدش الحياء أو يخالف تقاليد وعادات المجتمع الكويتي، سواء خلال عملية القبول أو بعده</p>
                <strong className="ml-2"> .2 </strong>
              </div>

              <div className="flex text-right justify-end w-full rtl">
                <p> أتعهد بالحفاظ على سمعة الجامعة، والامتناع عن التشهير بها أو نشر الشائعات عنها أو عن موظفيها، سواء داخل أو خارج الحرم الجامعي</p>
                <strong className="ml-2"> .3 </strong>
              </div>

            </div>
          </div>

        </div>


        {/* Checkbox */}
        <div className="flex items-center mt-8 mb-4">
          <input
            id="agree"
            type="checkbox"
            checked={agreed}
            onChange={() => setAgreed(!agreed)}
            className="mr-2"
          />
          <label htmlFor="agree" className="text-gray-700">
            I have read and agree to the above declaration /
          </label>
        </div>
        
        <p className="text-center rtl text-base leading-relaxed">
          انا____ <strong className="text-red-500" >{formData.arabicFirstName?.value}</strong>____ بطاقة المدنية رقم___<strong className="text-red-500" >{formData.civilId?.value}</strong>___اقر و اوافق على جميع الشروط والاحكام المذكورة اعلاه

        </p>

        {/* Buttons */}
        <div className="mt-4 flex justify-between">
          <button
            onClick={handleBack}
            className="bg-gray-300 text-gray-800 font-bold px-8 py-3 rounded-lg"
            type="button"
          >
            Back
          </button>
          <button
            onClick={handleSubmit}
            className={`font-bold px-10 py-3 rounded-lg ${agreed
              ? "bg-[#b60041] text-white"
              : "bg-gray-300 text-gray-400 cursor-not-allowed"
              }`}
            disabled={!agreed}
            type="button"
          >
            Agree & Continue
          </button>
        </div>
      </div>
    </div >
  );
};

export default DeclarationPledgePage;


// <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm leading-6 text-gray-700">
//           {/* English Text - Left Column */}
//           <div className="space-y-4 text-left md:col-span-1 w-full">
//             <div className="h-full flex flex-col justify-between">
//               <p>
//                 • I also agree and pledge, during my admission and study period at the university:
//                 <p className="pb-1 text-bold"></p>
//                 <br /><strong> I. </strong> To adhere to and fully respect the rules and regulations of the American University for Medical Sciences and the decisions issued by the university. Any violation thereof will subject me to the penalty determined by the university.
//                 <br /><strong> II. </strong> I also pledge to behave and conduct myself in a respectful and respectful manner, to address and treat all university staff and colleagues with respect, and to avoid anything that offends modesty or violates the traditions and customs of Kuwaiti society, whether during the admissions process or after admission.
//                 <br /><strong> III. </strong> I also pledge to preserve the university's reputation and refrain from defaming it or spreading rumors about it or its staff, whether inside or outside the university campus.
//               </p>

//             </div>
//           </div>

//           {/* Arabic Text - Right Column */}
//           <div className="space-y-4 text-right md:col-span-1 w-full rtl">
//             <div className="h-full flex flex-col justify-between">
//               <p>
//                 كما أتعهد وأوافق، خلال فترة قبولي ودراستي في الجامعة: •
//                 <br /> الالتزام التام بقواعد ولوائح الجامعة الأمريكية للعلوم الطبية والقرارات الصادرة عنها. وأي مخالفة لذلك ستعرضني للعقوبة التي تقررها الجامعة. <strong> .I </strong>
//                 <br /> أتعهد بالتصرف بأدب واحترام، ومخاطبة جميع موظفي الجامعة وزملائي باحترام، وتجنب كل ما يخدش الحياء أو يخالف تقاليد وعادات المجتمع الكويتي، سواء خلال عملية القبول أو بعده. <strong> .II </strong>
//                 <br /> أتعهد بالحفاظ على سمعة الجامعة، والامتناع عن التشهير بها أو نشر الشائعات عنها أو عن موظفيها، سواء داخل أو خارج الحرم الجامعي. <strong> .III </strong>
//               </p>

//             </div>
//           </div>
//         </div>